import {ObjectDocumentAssoc, ObjectDocumentAssocEntity} from "../../../model/object-document-assoc";
import {getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";

export type ObjectDocumentAssocSelectorProps = {
  // selector props here
};

export const objectDocumentAssocSelector = () => createSelector(
  [getUseQueryResultData<ObjectDocumentAssoc>],
  (data) => {
    return data ? transformObjectDocumentAssoc(data) : undefined;
  }
);

export const objectDocumentAssocsSelector = () => createSelector(
  [getUseQueryResultData<ObjectDocumentAssoc[]>],
  (data) => {
    return selectObjectDocumentAssocsAndTransform(
      data ?? [], {}
    );
  }
);

export const transformObjectDocumentAssoc = (value: ObjectDocumentAssoc): ObjectDocumentAssocEntity => {
  return ObjectDocumentAssocEntity.from(value)
}

export const selectObjectDocumentAssocs = (values?: ObjectDocumentAssoc[], selector?: ObjectDocumentAssocSelectorProps): ObjectDocumentAssoc[] => {
  if (!values) {
    return [];
  }

  return values.filter((v) => {
    let filterIn = true;
    return filterIn;
  });
};

export const selectObjectDocumentAssocsAndTransform = (values?: ObjectDocumentAssoc[], selector?: ObjectDocumentAssocSelectorProps): ObjectDocumentAssocEntity[] => {
  const selected = selectObjectDocumentAssocs(values, selector);
  return selected.map(transformObjectDocumentAssoc);
};
